document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-nsp-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-nsp-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-nsp-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-image-url');
        if (!url) return;

        thumbs.forEach(function (t) { t.classList.remove('nsp-gallery-thumb--active'); });
        thumb.classList.add('nsp-gallery-thumb--active');

        main.style.opacity = '0';
        window.setTimeout(function () {
          main.src = url;
          main.style.opacity = '1';
        }, 180);
      });
    });
  });
});
